
<template>
    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
       {{actionToBePerformed}}
      </h1>
    </section>

    <section class="content">
        <div class="row">
        <div class="col-xs-12">
          <div class="box">
            <div class="box-body">
              <div class="col-xs-12 col-md-12 col-lg-12">
                <form action="#"  method="post">
                  <div class="panel panel-default">
                    <div class="panel-heading">
                      <h3 class="panel-title">Configuration</h3>
                    </div>
                    <div class="panel-body">
                      <div class="row">
                        <div class="col-md-12 col-lg-12 col-xs-12">
                            <div class="form-group col-xs-6 col-sm-6 col-md-6">
                              <label for="name">Country</label>
                              <span title="The keyword and audience query will only work for the country which is selected from this dropdown."><i class="fa fa-info-circle required"></i></span>
                              <nv-select class="form-control" @change="selectedCountry" v-bind:class="{'form-group--error': submitted && !$v.gRowObj.country_id.required }" 
                              id="country_id" v-model="gRowObj.country_id">
                                <option value="">--Choose a Country--</option>
                                <option v-for="data in countryList" 
                                :selected="data.country_id === gRowObj.country_id" :key="data.country_id" :value="data.country_id">{{data.country_name}}</option>                    
                              </nv-select>
                              <span v-if="submitted && !$v.gRowObj.country_id.required" class="text-red pull-right">Please choose a country.</span>
                            </div>
                          <div class="form-group col-xs-6 col-sm-6 col-md-6">
                              <label for="type" class="required">Customer</label>                  
                              <nv-select class="form-control" @change="selectedClient" v-bind:class="{'form-group--error': submitted && !$v.gRowObj.client_id.required }" 
                              id="client_id" v-model="gRowObj.client_id" >
                                  <option value="">--Choose an Customer--</option>
                                  <option v-for="data in clientList" :key="data.id" :value="data.id"
                                  :selected="data.id === gRowObj.client_id">{{data.name}}</option>                      
                              </nv-select>
                              <span v-if="submitted && !$v.gRowObj.client_id.required" class="text-red pull-right">Please choose a client.</span>
                            </div>
                        </div>
                      </div>
                      <div class="row">
                          <div class="col-md-12 col-lg-12 col-xs-12">
                            <div class="form-group col-xs-4 col-sm-4 col-md-4">
                                <label for="type" class="required">Keyword Name</label>                  
                                <input type="text" v-bind:class="{'form-group--error': submitted && !$v.gRowObj.keyword_name.required }"
                                v-model="gRowObj.keyword_name" class="form-control" id="keyword_name" placeholder="Keyword Name" /> 
                                <span v-if="submitted && !$v.gRowObj.keyword_name.required" class="text-red pull-right">Please Click on Generate Keyword Button OR Enter Keyword.</span>
                            </div>
                            <div class="form-group col-xs-2 col-sm-2 col-md-2">
                                <button type="button" class="btn btn-primary" style="margin-top:25px;" @click="generateKeyword">Generate Keyword</button>
                            </div>
                            <div class="form-group col-xs-4 col-sm-4 col-md-4">
                                <label for="type" class="required">Audience Name</label>                  
                                <input type="text" v-bind:class="{'form-group--error': submitted && !$v.gRowObj.audience_name.required }"
                                v-model="gRowObj.audience_name" class="form-control" id="audience_name" placeholder="Audience Name" /> 
                                <span v-if="submitted && !$v.gRowObj.audience_name.required" class="text-red pull-right">Please Click on Generate Audience Button OR Enter Audience.</span>
                            </div>
                            <div class="form-group col-xs-2 col-sm-2 col-md-2">
                                <button type="button" class="btn btn-primary" style="margin-top:25px;" @click="generateAudience">Generate Audience</button>
                            </div>
                           </div>
                      </div>
                      <div class="row">
                          <div class="col-md-12 col-lg-12 col-xs-12">
                            <div class="form-group col-xs-6 col-sm-6 col-md-6">
                                <div>
                                    <label for="name" class="required">Type</label>
                                    <nv-select class="form-control"  id="apppackage" name="apppackage" v-bind:class="{'form-group--error': submitted && !$v.gRowObj.appPackage.required }"
                                    v-model="gRowObj.appPackage" @change="onChangeType($event)">
                                        <option value="">--Choose an App Package--</option>
                                        <option v-for="(data, index) in appPackages" :key="index" :value="data.value">{{data.name}}</option>
                                    </nv-select>
                                    <span v-if="submitted && !$v.gRowObj.appPackage.required" class="text-red pull-right">Please choose an app package.</span>
                                </div>
                            </div>
                            <div class="form-group col-xs-6 col-sm-6 col-md-6">
                                <div>
                                    <label for="name" class="required" v-show="gRowObj.appPackage!=='journey'">Conversation</label>
                                    <label for="name" class="required" v-show="gRowObj.appPackage==='journey'">User Journey</label>
                                    <treeselect
                                        placeholder="--Choose an app--" 
                                        :multiple="false"
                                        :disabled="gRowObj.appPackage == ''" 
                                        :options="conversationApps" 
                                        v-model="gRowObj.conversation"
                                        v-bind:class="{'form-group--error': submitted && !$v.gRowObj.conversation.required }" />
                                      <span v-if="submitted && !$v.gRowObj.conversation.required" class="text-red pull-right">Please choose a conversation.</span>
                                </div>
                          </div>
                          </div>
                      </div> 
                      <div class="row">
                          <div class="col-md-12 col-lg-12 col-xs-12">
                            <div class="form-group col-xs-6 col-sm-6 col-md-6">
                                <label for="name" class="required">Google Sheet URL</label>
                                <input type="text" v-bind:class="{'form-group--error': submitted && !$v.gRowObj.spreadsheetURL.required }" 
                                v-model="gRowObj.spreadsheetURL" class="form-control" id="spreadsheetURL" placeholder="Google Sheet URL" />
                                <span v-if="submitted && !$v.gRowObj.spreadsheetURL.required" class="text-red pull-right">Please enter URL of Google Sheet.</span>
                            </div>
                            <div class="form-group col-xs-6 col-sm-6 col-md-6">
                              <div class="display-content">
                                <label class="checkbox-inline" style="margin-top: 23px;">
                                  <input type="checkbox" :checked="gRowObj.isUploadInJOR" v-model="gRowObj.isUploadInJOR" /> 
                                  <b>Onboard users to JOR? <span title="Please select this field only when users are to be onboarded directly into the selected JoR"><i class="fa fa-info-circle margin-10"></i></span></b>
                                </label>
                              </div>
                            </div>
                          </div>
                      </div>                                     
                  </div>
                  </div>
                  <div class="row">
                    <div class="action-button">
                      <button type="button" class="btn btn-primary" @click="close">Cancel</button>
                      <button type="button" class="btn btn-primary margin-left-20px" @click="uploadFHIUsers()">Submit</button>
                    </div>
                  </div>
                  <div class="row" style="margin: 30px 10px 30px 10px;font-size: medium;line-height:30px;">
                    <label style="font-size: large;" for="notes">Instructions:-</label>
                    <ul>
                      <li><div id="notes">Please upload the Google Sheet in this folder :- <a href="https://drive.google.com/drive/folders/1Vb7nmtQoqEvBFjW3LqoSUtfptnx5u6sq" target="_blank">https://drive.google.com/drive/folders/1Vb7nmtQoqEvBFjW3LqoSUtfptnx5u6sq</a></div></li>
                      <li><b style="color: red;">CAUTION: </b>The google sheet which needs to be uploaded should only contains the details in a specific format.
                        <ul>
                          <li><b>Phone Number</b> (Add the country code before the phone number and do not enter any kind of special characters in it)</li>
                          <li><b>Language</b> must be one of the following options :- eng, hi, swa, hau (Please take a note of this, and change the language to one of these options wherever necessary)</li>
                          <li><b>Gender</b> must be one of the following options :- man, woman, nonbinary (Please take a note of this, and do not use male or female in the google sheets)</li>
                          <li><b>Age</b></li>
                          <li><b>Pincode</b></li>
                          <li><b>Country</b> (Make a note that the first letter of the country must be a capital letter i.e. {{activeCountryList.join(', ')}})</li>
                        </ul>
                      </li>
                      <li>The sequence of the users data must be <b>Phone Number, Language, Gender, Age, Pincode, Country</b>.</li>
                      <li><div id="referenceSheet">Here is a demo sheet for your reference :- <a href="https://docs.google.com/spreadsheets/d/18HVveQmCpHEAnddx3Neaxem1wITtPlMCr0QpDq_e03I/edit?usp=sharing" target="_blank">https://docs.google.com/spreadsheets/d/18HVveQmCpHEAnddx3Neaxem1wITtPlMCr0QpDq_e03I/edit?usp=sharing</a></div></li>
                    </ul>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <BlockUI v-if="loading"><i class="fa fa-cog fa-spin fa-3x fa-fw"></i><br/>Please wait...</BlockUI>
    </div>
</template>
<script>
  import Treeselect from '@riophae/vue-treeselect'
  import { required } from 'vuelidate/lib/validators'
  import api from '../../../utils/api'
  import { formatDate, getSelectorValue, getActiveCountryList } from '../../../utils/utilities'
  import { instanceCountriesMapping } from '../../../config/constants'
  import moment from 'moment'
  import { getAccessToken } from '../../../utils/auth'
  export default {
    name: 'modal',
    components: {
      Treeselect
    },
    validations: {
      gRowObj: {
        country_id: { required },
        client_id: { required },
        spreadsheetURL: { required },
        appPackage: { required },
        conversation: { required },
        keyword_name: { required },
        audience_name: { required }
      }
    },
    data () {
      return {
        appPackages: [
            { name: 'Conversation', value: 'conversation' },
            { name: 'User Journey', value: 'journey' }
        ],
        activeCountryList: [],
        currentDate: moment(new Date()).format('YYYY_MM_DD_HH_mm_ss'),
        loading: false,
        isEdit: false,
        countryList: [],
        clientList: [],
        conversationApps: [],
        conversationAppCopy: [],
        formatDate: formatDate,
        gRowObj: {
          country_id: '',
          client_id: '',
          spreadsheetURL: '',
          isUploadInJOR: false,
          keyword_name: null,
          audience_name: null,
          appPackage: '',
          conversation: null
        },
        submitted: false,
        submittedRes: false,
        actionToBePerformed: 'Upload Users',
        countryName: '',
        countryAlise: '',
        clientName: '',
        keywordExistError: false
      }
    },
    methods: {
      close () {
        this.submitted = false
        this.gRowObj = {
          country_id: '',
          client_id: '',
          spreadsheetURL: '',
          isUploadInJOR: false,
          keyword_name: null,
          audience_name: null,
          appPackage: '',
          conversation: null
        }
        this.$router.replace('create')
      },
      selectedCountry () {
        this.countryList.forEach((country) => {
          if (country.country_id === this.gRowObj.country_id) {
            this.countryAlise = country.country_alise.charAt(0).toUpperCase() + country.country_alise.slice(1)
            this.countryName = country.country_name
            return
          }
        })
      },
      selectedClient () {
        this.clientList.forEach((client) => {
          if (client.id === this.gRowObj.client_id) {
            this.clientName = client.name
            return
          }
        })
      },
      generateKeyword () {
        if (this.clientName && this.countryAlise) {
          this.gRowObj.keyword_name = `${this.clientName}_${this.countryAlise}_${this.currentDate}`
        }
      },
      generateAudience () {
        if (this.clientName && this.countryAlise) {
          this.gRowObj.audience_name = `${this.clientName}_${this.countryAlise}_NewUsers_${this.currentDate}`
        }
      },
      async onChangeType (event) {
        // Keeping a copy for further use
        this.gRowObj.conversation = null

        if (this.conversationAppCopy.length === 0) {
          this.conversationAppCopy = this.conversationApps
        }
        if (event.target.value === 'conversation') {
          this.conversationApps = this.conversationAppCopy.filter(item => item.type !== 'journey' && item.type !== 'journeyReminder')
        } else if (event.target.value === 'journey') {
          this.conversationApps = this.conversationAppCopy.filter(item => item.type === 'journey' || item.type === 'journeyReminder')
        } else {
          this.conversationApps = []
          this.gRowObj.conversation = null
        }
      },
      async getCountryList () {
        return new Promise(resolve => {
          api.buildRequest('getCountryList', 'POST').then(({ data }) => {
            const domainName = window.location.hostname
            const possibleCountries = instanceCountriesMapping[domainName].countries
            this.countryList = data.payload.filter(item => item.country_name.toLowerCase() !== 'global' && possibleCountries.includes(item.country_name.toLowerCase()))
            this.countryList.forEach((item) => {
              item.country_name = item.country_name.replace(/ /g, '_')
            })
            resolve()
          }).catch(({ response }) => {
            resolve(true)
            this.loading = false
            this.$swal({
              title: 'Failure',
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
        })
      },
      async getClientList () {
        return new Promise(resolve => {
          api.buildRequest('getClientData', 'POST').then(({ data }) => {
            this.clientList = data.payload
            resolve()
          }).catch(({ response }) => {
            resolve(true)
            this.loading = false
            this.$swal({
              title: 'Failure',
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
        })
      },
      getSmsAppIdByName (appName) {
        const params = {
          appName: appName
        }
        return new Promise((resolve, reject) => {
          api.buildRequest('/getSmsAppIdByName', 'POST', params)
          .then(response => {
            if (response.status === 200) {
              console.log('inside getSmsAppIdByName', response)
              resolve(response)
            }
          }).catch(({ response }) => {
            this.loading = false
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
        })
      },
      loadApps (deployed = false) {
        this.loading = true
        let url = 'app'
        url += deployed ? '?deployed=true' : ''
        api.buildRequest(url, 'GET')
          .then(response => {
            if (response.status === 200) {
              if (deployed) {
                this.conversationApps = response.data.payload.apps.map(convo => { return { id: convo.name, type: (convo.config && convo.config.type), label: `${convo.name} - ${this.formatDate(convo.deployedDate, 'd/M/Y hh:ss')}` } })
              }
              this.conversationAppCopy = this.conversationApps
              this.loading = false
            }
          }).catch(({ response }) => {
            this.loading = false
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
      },
      async uploadFHIUsers () {
        this.submitted = true
        this.$v.gRowObj.$touch()
        if (this.$v.gRowObj.$invalid) {
          return
        }
        await this.addUsers()
        this.submitted = false
      },
      async addUsers () {
        this.loading = true
        var param = this.gRowObj
        param.audience_name = param.audience_name.trim()
        param.keyword_name = param.keyword_name.trim()

        // check keyword already exists or not
        let dataCountry = 'data.country'
        let queryParams = {
          selector: {
            keyword: param.keyword_name,
            [dataCountry]: this.countryName,
            isdeleted: false
          }
        }
        queryParams.selector = getSelectorValue(queryParams.selector)
        try {
          const response = await api.buildRequest('/checkKeywordExists', 'POST', queryParams)
          if (response.status === 200 && response.data.payload !== null) {
            this.loading = false
            this.$swal({
              type: 'error',
              text: 'Keyword Already Exists'
            })
            this.keywordExistError = true
          }
        } catch (response) {
          this.loading = false
          this.$swal({
            type: 'error',
            text: response ? response.data.payload.message : 'An error occurred'
          })
        }
        if (this.keywordExistError) {
          return new Promise(resolve => {
            this.keywordExistError = false
            resolve()
          })
        }

        // To find Google Sheet Id from URL
        param.spreadsheetURL = param.spreadsheetURL.trim()
        param.spreadsheetId = param.spreadsheetURL.split('/d/')[1].split('/edit')[0]

        param.country = this.countryName
        param.clientName = this.clientName
        param.user_source = `${this.clientName}_${this.countryAlise}`
        const resSmsApp = await this.getSmsAppIdByName(`${param.conversation}`)
        if (resSmsApp.status === 200) {
          if (resSmsApp.data && resSmsApp.data.payload && resSmsApp.data.payload.length) {
            param.conversationId = resSmsApp.data.payload[0].appId
          }
        }

        console.log('Params to send', param)

        // call add
        return new Promise(resolve => {
          api.buildRequest('csvToDB', 'POST', param, { headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getAccessToken()}` } }).then(({ data }) => {
            if (data.payload && data.payload.type === 'success') {
              this.$swal({
                width: 600,
                title: data.payload.text,
                type: 'success',
                html: `<table style="table-layout:fixed; width:100%; font-size: initial">
                        <tr>
                          <td style="width:40%">Keyword</td>
                          <td><a target="_blank" href="/NewKeywordsDetails?keywordId=${data.payload.keywordId}">${data.payload.keyword}</a></td>
                        </tr>
                        <tr>
                          <td>Audience query</td>
                          <td><a target="_blank" href="/audience-builder/upload?queryId=${data.payload.audienceQueryId}">${data.payload.audience_query_name}</a></td>
                        </tr>
                        <tr>
                          <td>successAccountIds: (${data.payload.successAccountIds.length})</td>
                          <td><div style="max-height: 100px; overflow-y: auto;">${data.payload.successAccountIds.join('\n')}</div></td>
                        </tr>
                        <tr>
                          <td>existingAccountIds: (${data.payload.existingAccountIds.length})</td>
                          <td><div style="max-height: 100px; overflow-y: auto;">${data.payload.existingAccountIds.join('\n')}</div></td>
                        </tr>
                      </table>`
              }).then(() => {
                this.gRowObj = {
                  country_id: '',
                  client_id: '',
                  spreadsheetURL: '',
                  isUploadInJOR: false,
                  keyword_name: null,
                  audience_name: null,
                  appPackage: '',
                  conversation: null
                }
                this.currentDate = moment(new Date()).format('YYYY_MM_DD_HH_mm_ss')
                this.$router.push({ name: 'user-upload/create' })
              })
              resolve()
              this.loading = false
            } else {
              resolve(true)
              this.loading = false
              this.$swal({
                title: data.payload ? data.payload.type : 'error',
                type: 'error',
                html: `<div> ${data.payload ? data.payload.text : 'An error occurred'}</div>
                       <div> Payload: ${JSON.stringify(data.payload)}</div>`
              })
            }
          }).catch(({ response }) => {
            resolve(true)
            this.loading = false
            this.$swal({
              title: 'Failure',
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
        })
      }
    },
    async mounted () {
      this.gRowObj = {
        country_id: '',
        client_id: '',
        spreadsheetURL: '',
        isUploadInJOR: false,
        keyword_name: null,
        audience_name: null,
        appPackage: '',
        conversation: null
      }
      this.loading = true
      await this.getCountryList()
      await this.getClientList()
      await this.loadApps(true)
      this.activeCountryList = await getActiveCountryList()
      this.actionToBePerformed = 'Upload Users'
      this.loading = false
    }
  }
</script>
<style>
.margin-left-20px {
  margin-left: 20px;
}
.form-group .padding-15px {
  padding: 0 15px;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 90%;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}
.body.modal-mask {
  position:fixed;
  height: 100vh;
  overflow-y: hidden;
}
.modal-header h3 {
  width: 100%;
  margin-top: 0;
  color: black;
}
.modal-body {
  overflow: auto;
  margin: 20px 0;
}
.modal-default-button {
  float: right;
}
.modal-enter {
  opacity: 0;
}
.modal-leave-active {
  opacity: 0;
}
.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
.disable {
  color: #b3b1b1;
}
.v-autocomplete {
  position:relative;
}
.v-autocomplete-input {
  padding:10px 15px;
  height:34px;
}
.v-autocomplete-list {
  width:calc(100% - 30px);
  border:1px solid #d2d6de;
  position:absolute;
  top:58px;
  z-index:111;
  list-style: none;
  padding: 0%;
  max-height: 110%;
  overflow: overlay;
}
.v-autocomplete-list-item {
  width:100%;
  border-bottom:1px solid #d2d6de;
  padding:6px 12px;
  font-size:14px;
  background-color:white;
  cursor:pointer;
}
.v-autocomplete-list-item:last-child {
  width:100%;
  border-bottom:none;
}
.v-autocomplete-list-item:hover {
  background-color: #d2d6de;
}
.msg-table thead, .msg-table tbody{
  display: inline-block;
}
.msg-table thead{
  width: calc(100% - 17px);
}
.msg-table tbody{
  max-height: calc(100vh - 300px);
  overflow: auto;
}
.msg-table th, .msg-table td {
  display: block;
  float: left;
}
.msg-table th:first-child, .msg-table td:first-child{
  width: calc(20% - 53px);
}
.msg-table th:nth-child(2), .msg-table td:nth-child(2), .msg-table th:nth-child(3), .msg-table td:nth-child(3){
  width: 40%;
}
.msg-table th:nth-child(4), .msg-table td:nth-child(4){
  width: 53px;
}
.alert-success{
   background-color:#d4edda !important; 
   border-color:#d4edda !important
}
.alert-danger{
   background-color:#f7d7da !important; 
   border-color:#f7d7da !important
}
.alert-warning{
   background-color:#fff3cd !important; 
   border-color:#fff3cd !important
}
.alert-info{
   background-color:#cce5ff !important; 
   border-color:#cce5ff !important
}

</style>



// WEBPACK FOOTER //
// index.vue?63539dcf